import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext/AuthContext';
import { TabProvider } from './context/TabContext/TabContext';
import { AccessControlProvider } from './context/AccessControlContext/AccessControlContext';

import Router from './Router';
import Layout from './components/layouts/Layout/Layout';
import Loader from './components/Loader/Loader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProviderComponent } from './context/ThemeContext/ThemeContext';
import PixelTikTok from './utils/pixel/PixelTikTok';

function TikTokPageView() {
  const location = useLocation();
  useEffect(() => {
    window.ttq?.page();
  }, [location.pathname, location.search]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <PixelTikTok />
      <TikTokPageView />
      <AccessControlProvider>
        <div className="App">
          <AuthProvider>
            <ThemeProviderComponent>
              <TabProvider>
                <Suspense fallback={<Loader global={true} />}>
                  <Layout>
                    <Router />
                  </Layout>
                </Suspense>
              </TabProvider>
            </ThemeProviderComponent>
          </AuthProvider>
        </div>
        <ToastContainer />
      </AccessControlProvider>
    </BrowserRouter>
  );
}
